import { Paper, Avatar, Skeleton, TypographyElement, Icon, Icons, RateStars } from 'UI'
import { TrainerPrimaryPath } from 'navigation/Routes'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'

const useStyles = createUseStyles(style)

export default ({
  AuthorFirstName = '',
  AuthorLastName = '',
  AuthorPhoto,
  Rating,
  ViewersCount,
  ReviewersCount,
  goToTrainer,
  AuthorId,
  Id,
  loading,
  margin,
  scrollToReviews
}) => {
  const theme = useTheme()
  const {
    infos,
    icons,
    rateStarsClass,
    infosLines,
    lastInfosLines,
    infosLinesViewers
  } = useStyles({ margin, infosLinesNoPadding: !Rating, gutterBottomForInfoLines: !!ViewersCount || !!Rating })

  return (
    <Paper noHover={loading} className={infos}>
      <div className={infosLines}>
        <Avatar
          width={28}
          height={28}
          widthTablet={28}
          heightTablet={28}
          widthMobile={28}
          heightMobile={28}
          loading={loading}
          key={`${Id}-${loading}`}
          img={AuthorPhoto}
          name={`${AuthorFirstName[0]}.${AuthorLastName[0]}`}
          handleClick={() => goToTrainer(`${TrainerPrimaryPath}/${AuthorId}`)}
        />
        {
          loading
            ? <Skeleton wrapperWidth='70%' lines={1} width='100%' height={26} margin='0 0 0 8px' />
            : (
              <TypographyElement
                variant='heading6'
                color={theme.primary[0]}
                spacing='0 0 0 8px'
                Component='a'
                href={`${TrainerPrimaryPath}/${AuthorId}`}
                handleClick={(e) => {
                  e.preventDefault()
                  goToTrainer(`${TrainerPrimaryPath}/${AuthorId}`)
                }}
                cursor='pointer'
              >
                {`${AuthorFirstName} ${AuthorLastName.toUpperCase()}`}
              </TypographyElement>
              )
        }
      </div>
      {
        loading
          ? <Skeleton lines={3} width={['50%', '60%', '40%']} height={25} gap={16} />
          : (
            <>
              {
                !!ViewersCount &&
                  <div className={infosLinesViewers}>
                    <Icon iconName={Icons.user} style={icons} />
                    <TypographyElement
                      variant='body1'
                      spacing='0 0 0 4px'
                    >
                      {`${ViewersCount} ${Text.participants}`}
                    </TypographyElement>
                  </div>
              }
              {
                !!Rating &&
                  <div className={lastInfosLines}>
                    <div onClick={scrollToReviews}>
                      <RateStars secondary value={Rating} className={rateStarsClass} />
                    </div>
                    <TypographyElement
                      variant='caption'
                      spacing='0 0 0 2px'
                      margin='0 0 2px 0'
                    >
                      {`(${ReviewersCount})`}
                    </TypographyElement>
                  </div>
              }
            </>
            )
      }
    </Paper>
  )
}
